import script from "./SalesmanBusinessTripManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanBusinessTripManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanBusinessTripManagement.vue?vue&type=style&index=0&id=1308c1b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1308c1b4"]])

export default __exports__